import { Desdobramento, DesdobramentoFiltro, ItemNumeroPedidoBloqueioDesdobramento } from "app/components/desdobramento/Desdobramento"
import { BaseApi } from "./BaseApi"
import { DomainDataError } from "../types/DomainDataError"

export class DesdobramentoApi extends BaseApi {
    async PesquisarOrcamentosDesdobramento(filtro: DesdobramentoFiltro): Promise<Desdobramento[]> {
        const resposta = await this
            .api
            .post(`/Desdobramento/PesquisarOrcamentosDesdobramento`, filtro)
        return resposta?.data
    }

    async BloqueiaDesbloqueiaOrcamentoParaManutencao(input: ItemNumeroPedidoBloqueioDesdobramento[]): Promise<DomainDataError<boolean> | boolean> {
        const resposta = await this
            .api
            .post(`/Desdobramento/BloqueiaDesbloqueiaOrcamentoParaManutencao`, input)
        return resposta?.data
    }

    async ConfirmarDesdobramento(input: {listaNumeroPedidoBloqueiaDesdobramento: ItemNumeroPedidoBloqueioDesdobramento[], senhaLiberacao: string}): Promise<boolean> {
        const resposta = await this
            .api
            .post(`/Desdobramento/ConfirmarDesdobramento`, input)
        return resposta?.data
    }
}